module.exports = "/_next/static/images/loading_06-ac78282ce50822af20e96a58ef1878a8.png";